import ContractorsDeleteModal from "./ContractorsDeleteModal";

export default ContractorsDeleteModal;
